import { RootState } from '../index';
import { Product } from '../../Model/ProductModel';

export const selectProducts = (state: RootState): Product[] => state.product.list;

export const selectDirtyIds = (state: RootState): number[] => state.product.dirtyIds;

export const selectDirtyProducts = (state: RootState): Product[] =>
  state.product.list.filter(
    (p): p is Product & { id: number } =>
      p.id !== null && state.product.dirtyIds.includes(p.id)
  );

export const selectHasModifications = (state: RootState): boolean =>
  state.product.dirtyIds.length > 0;

export const selectProductById = (id: number | null) => (state: RootState): Product | undefined =>
  state.product.list.find(p => p.id === id);
